import e from"styled-components";const i=e.div`
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	border-radius: ${({borderRadius:e})=>`${e}px`};
	background-color: ${({theme:e})=>"dark"===e.name?"#2A2A2A":"#f1f2f4"};
	border: 0.71px solid ${({theme:e})=>e.border.black10};
	display: flex;
	flex-direction: ${({isOneColumn:e})=>e?"row":"column"};
	justify-content: ${({isOneColumn:e})=>e?"flex-start":"space-between"};
	height: 100%;
`,t=e.div`
	background: url(${({imageUrl:e})=>e});
	background-size: cover;
	background-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
	border-radius: ${({borderRadius:e})=>`${e}px`};
	position: relative;

	${({isOneColumn:e})=>e?"\n      width: 284px;\n      height: 241px;\n      ":"\n      height: 170px;\n  "}
`,o=e.div`
	position: absolute;
	inset: 0;
	background: linear-gradient(
		${({isOneColumn:e})=>e?"90deg":"180deg"},
		${({theme:e})=>"dark"===e.name?"#2A2A2A":"#f1f2f4"}00 0%,
		${({theme:e})=>"dark"===e.name?"#2A2A2A":"#f1f2f4"}33 41%,
		${({theme:e})=>"dark"===e.name?"#2A2A2A":"#f1f2f4"}e6 80%,
		${({theme:e})=>"dark"===e.name?"#2A2A2A":"#f1f2f4"}ff 91%
	);
`,n=e.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	position: relative;
	justify-content: ${({isOneColumn:e})=>e?"space-around":"flex-start"};
	padding: ${({isOneColumn:e})=>e?"24px 40px":"12px 14px"};
	flex: ${({isOneColumn:e})=>e?1:"0 0 auto"};
`,r=e.div`
	display: flex;
	flex-direction: column;
	gap: ${({isOneColumn:e})=>e?"0px":"8px"};
`,a=e.h1`
	margin: 0;
	color: ${({theme:e})=>e.text.input};
	max-width: 70%;
	padding-top: ${({isOneColumn:e})=>e?"0px":"22px"};
	font-size: ${({isOneColumn:e})=>e?"32px":"22px"};
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
	font-weight: 500;
`,d=e.p`
	margin: 0;
	font-size: 14px;
	line-height: 18px;
	color: ${({theme:e})=>e.text.text};
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
	width: 80%;
	white-space: pre-wrap;
	opacity: 0.6;
`,p=e.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:e})=>e};
	background: ${({background:e})=>e};
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
	border-radius: 9999px;
	width: fit-content;
	max-width: 80%;
	height: 26px;
	box-sizing: border-box;
	text-overflow: ellipsis;
	overflow: hidden;
	display: inline-block;
`,s=e.div`
	display: flex;
	justify-content: ${({hasLabel:e})=>e?"space-between":"end"};
	align-items: center;
`,l=e.div`
	opacity: 0.6;

	${({isAbsolute:e})=>e&&"\n    position: absolute;\n    bottom: 12px;\n    right: 14px;\n  "}
`;export{l as CardArrowContainer,i as CardContainer,n as CardContentContainer,t as CardCover,s as CardFooter,r as CardHeader,a as CardHeading,p as CardLabel,o as CardOverlay,d as CardParagraph};
